import { createSingleRecordReadOnlyApi } from '@skylabs-digital/react-proto-kit';
import { userStateSchema } from '../schemas/userState.schema';

export type {
  UserBudgetState,
  UserPreferenceEntry,
  UserRecentNotification,
  UserState,
  UserStats,
} from '../schemas/userState.schema';

export const userStateApi = createSingleRecordReadOnlyApi('users/:userId/state', userStateSchema);
